<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-info">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-solid fa-circle-info"></i>
                                <span>Info extra</span>
                            </mat-card-title>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <div>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                    (change)="onInfoChange($event)" value="info">
                                    <mat-button-toggle value="info">Info Extra</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere.prim_sot" value="sotul">Soțul</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere.second_sot" value="sotia">Soția</mat-button-toggle>
                                    <mat-button-toggle *ngIf="cerere.copii && cerere.copii.length"
                                        value="copii">Copii</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <!-- Info Extra -->
                    <ng-container *ngIf="selectedInfoStatus === 'info'">
                        <table class="table table-condensed table-wrapper-box">
                            <tbody *ngIf="cerere.informatii">
                                <tr *ngFor="let field of getCurrentFormFields()">
                                    <td width="40%" class="text-center"><strong>{{ field.label }}</strong></td>
                                    <td width="60%">
                                        <ng-container [ngSwitch]="field.type">
                                            <!-- Boolean Type -->
                                            <ng-container *ngSwitchCase="'boolean'">
                                                {{ cerere.informatii[field.value] ? 'Da' : 'Nu' }}
                                            </ng-container>

                                            <!-- Date Type -->
                                            <ng-container *ngSwitchCase="'date'">
                                                {{ cerere.informatii[field.value] ? (
                                                cerere.informatii[field.value] | date:'dd-MM-yyyy HH:mm'
                                                ) : 'N/A' }}
                                            </ng-container>

                                            <!-- Situatie militara -->
                                            <ng-container *ngSwitchCase="'situatie_militara'">
                                                {{ mapValueToName(cerere.informatii[field.value], militaryStatuses) }}
                                            </ng-container>

                                            <!-- Rang militar -->
                                            <ng-container *ngSwitchCase="'rang_militar'">
                                                {{ mapValueToName(cerere.informatii[field.value], militaryRanks) }}
                                            </ng-container>

                                            <!-- Regim matrimonial -->
                                            <ng-container *ngSwitchCase="'regim_matrimonial'">
                                                {{ mapValueToName(cerere.informatii[field.value], matrimonialRegimes) }}
                                            </ng-container>

                                            <ng-container *ngSwitchDefault>
                                                {{
                                                cerere.informatii[field.value] ? cerere.informatii[field.value] : 'N/A'
                                                }}
                                            </ng-container>
                                        </ng-container>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody *ngIf="!cerere.informatii">
                                <tr>
                                    <td width="40%" class="text-center"><strong>Observații cerere</strong></td>
                                    <td width="60%">N/A</td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                    <!-- Sotul -->
                    <ng-container *ngIf="selectedInfoStatus === 'sotul' && cerere.prim_sot">
                        <app-spouse [spouse]="cerere.prim_sot"></app-spouse>
                    </ng-container>
                    <!-- Sotia -->
                    <ng-container *ngIf="selectedInfoStatus === 'sotia' && cerere.second_sot">
                        <app-spouse [spouse]="cerere.second_sot"></app-spouse>
                    </ng-container>
                    <!-- Copii -->
                    <ng-container *ngIf="selectedInfoStatus === 'copii' && cerere.copii && cerere.copii.length">
                        <div class="d-flex flex-row flex-wrap gap-2 m-3">
                            <button *ngFor="let copil of cerere.copii; index as index" type="button"
                                class="btn btn-light info-btn" (click)="onChildChange(index)">
                                <span class="text">
                                    <i class="fa-regular fa-user"></i>
                                    Copil #{{ index + 1 }}
                                </span>
                            </button>
                        </div>
                        <div *ngFor="let copil of cerere.copii; index as index">
                            <table *ngIf="index === selectedChildIndex" class="table table-condensed table-wrapper-box">
                                <tbody>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Copil</strong>
                                        </td>
                                        <td class="text-left">#{{ index + 1 }}</td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Nume</strong>
                                        </td>
                                        <td class="text-left">{{ copil.nume + ' ' + copil.prenume }}</td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Data nașterii</strong>
                                        </td>
                                        <td class="text-left">{{ copil.data_nasterii || 'N/A' }}</td>
                                    </tr>
                                    <tr>
                                        <td width="40%" class="text-center">
                                            <strong>Locul nașterii</strong>
                                        </td>
                                        <td class="text-left">{{ (copil.judet && copil.oras)
                                            ? (copil.judet + ", " + copil.oras) : 'N/A' }}
                                        </td>
                                    </tr>
                                    <tr *ngIf="copil.certificat_nastere">
                                        <td width="40%" class="text-center">
                                            <strong>Certificat naștere</strong>
                                        </td>
                                        <td class="text-left">{{ copil.certificat_nastere }}</td>
                                    </tr>
                                    <tr *ngIf="copil.nume_tata">
                                        <td width="40%" class="text-center">
                                            <strong>Nume tată</strong>
                                        </td>
                                        <td class="text-left">{{ copil.nume_tata }}</td>
                                    </tr>
                                    <tr *ngIf="copil.nume_mama">
                                        <td width="40%" class="text-center">
                                            <strong>Nume mamă</strong>
                                        </td>
                                        <td class="text-left">{{ copil.nume_mama }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>